import { createContext, useContext, type ReactNode } from 'react';
import { useBackendStatus, type BackendStatus } from '@/hooks/useBackendStatus';

interface BackendStatusContextValue {
  status: BackendStatus;
  lastChecked: Date | null;
  recheck: () => void;
}

const BackendStatusContext = createContext<BackendStatusContextValue | null>(null);

export function BackendStatusProvider({ children }: { children: ReactNode }) {
  const value = useBackendStatus();
  return (
    <BackendStatusContext.Provider value={value}>
      {children}
    </BackendStatusContext.Provider>
  );
}

export function useBackendStatusContext(): BackendStatusContextValue {
  const ctx = useContext(BackendStatusContext);
  if (!ctx) {
    throw new Error('useBackendStatusContext must be used within BackendStatusProvider');
  }
  return ctx;
}
